import React, { useRef } from "react";
import { MenuItem, MenuList } from "@mui/material";
import { hasCompanyPermission, Permissions, translate } from "../../../../common/providers";
import { CustomMenuButton, icon, IconComponent, SearchInput } from "../../../../common/components";
import styles from "./PanelHeader.module.css";

export default function PanelHeader({
	isLoading,
	isUserProjectLeader,
	onAdd,
	onClearSearch,
	onClickPrivacy,
	onSearch,
	search,
}) {
	const menuButtonRef = useRef(null);
	const isMyCompanyProjectLeader = hasCompanyPermission(Permissions.PROJECT_LEADER);
	const isMyCompanyProjectManager = hasCompanyPermission(Permissions.PROJECT_MANAGER);
	const canCreateTeam = isMyCompanyProjectManager || isMyCompanyProjectLeader;

	const handleClickItem = (callback) => {
		menuButtonRef.current?.onClose();
		if (typeof callback === "function") {
			callback();
		}
	};

	return (
		<div className={styles.panelHeader}>
			<SearchInput
				fullWidth
				isLoading={isLoading}
				placeholder={translate("team-management.panel-header.placeholder.search-text")}
				value={search}
				onChange={onSearch}
				onClearSearch={onClearSearch}
			/>
			{isUserProjectLeader && (
				<CustomMenuButton
					ref={menuButtonRef}
					color="secondary"
					icon={icon.faSliders}
					position="bottom-end"
					size="sm"
					variant="outlined"
				>
					<MenuList className={styles.menuList}>
						{canCreateTeam && (
							<MenuItem className={styles.menuItem} onClick={() => handleClickItem(onAdd)}>
								<IconComponent
									className={styles.menuIcon}
									color="var(--icon-primary)"
									icon={icon.faPlus}
								/>
								<span>{translate("team-management.panel-header.create-new-team-btn")}</span>
							</MenuItem>
						)}
						<MenuItem className={styles.menuItem} onClick={() => handleClickItem(onClickPrivacy)}>
							<IconComponent className={styles.menuIcon} color="var(--icon-primary)" icon={icon.faEye} />
							<span>{translate("team-management.panel-header.privacy-btn")}</span>
						</MenuItem>
					</MenuList>
				</CustomMenuButton>
			)}
		</div>
	);
}
